import React, { useEffect, useRef, useState } from 'react';
import { baseUrl } from './config.js';
import { onMessageListener, requestPermission, deviceToken } from './firebase.js';
import { useAuth } from 'react-oidc-context';
import { BrowserRouter, Route, Routes, Outlet, NavLink, useNavigate } from 'react-router-dom';
import useToken from './useToken';
import Inicio from './Components/Inicio/Inicio.js';
import Dashboard from './Components/Dashboard/Dashboard.js';
import Stock from './Components/Stock/Stock.js';
import MisProductos from './Components/Stock/MisProductos.js';
import NavBar from './Components/NavBar/NavBar.js';
import NavBarCuenta from './Components/NavBar/NavBarCuenta.js';
import NavBarGestion from './Components/NavBar/NavBarGestion.js';
import Login from './Components/Login/Login.js';
import Footer from './Components/Footer/Footer.js';
import Faqs from './Components/Faqs/Faqs.js';
import About from './Components/About/About.js';
import Cuenta from './Components/Cuenta/Cuenta.js';
import Almacen from './Components/Almacen/Almacen.js';
import InfoAlmacen from './Components/InfoAlmacen/InfoAlmacen.js';
import MisPublicaciones from './Components/Publicaciones/MisPublicaciones.js';
import Publicaciones from './Components/Publicaciones/Publicaciones.js';
import Publicacion from './Components/Publicacion/Publicacion.js';
import Fotos from './Components/Fotos/Fotos.js';
import HostPersonas from './Components/Host/Personas.js';
import HostReservaciones from './Components/Host/Reservaciones.js';
import CalendarioReservaciones from './Components/CalendarioReservaciones/CalendarioReservaciones.js';
import HostAlmacenes from './Components/Host/Almacenes.js';
import Persona from './Components/Persona/Persona.js';
import BottomBar from './Components/BottomBar/BottomBar.js';
import Unirte from './Components/Unirte/Unirte.js';
import Reservar from './Components/Reservar/Reservar.js';
import Reserva from './Components/Reservar/Reserva.js';
import Inout from './Components/Inout/Inout.js';
import InoutHost from './Components/Inout/InoutHost.js';
import Reservados from './Components/Reservados/Reservados.js';
import Reservacion from './Components/Reservacion/Reservacion.js';
import Notificaciones from './Components/Notificaciones/Notificaciones.js';
import Contacta from './Components/Contacta/Contacta.jsx';

import Mensajes from './Components/Mensajes/Mensajes.jsx';

// cuenta
import DashEspacios from './Components/Dashboards/DashEspacios.js';
import DashAlmacenes from './Components/Dashboards/DashAlmacenes.js';
import DashPublicaciones from './Components/Dashboards/DashPublicaciones.js';
import DashUbicacion from './Components/Dashboards/DashUbicacion.js';
import DashFinanzas from './Components/Dashboards/DashFinanzas.js';
import DashFechas from './Components/Dashboards/DashFechas.js';
import ReservacionHost from './Components/Reservacion/ReservacionHost.js';


// test only
import Transferencia from './Components/Transferencia/Transferencia.js';

import { BuscadorProvider }  from './Components/Buscador/BuscadorContext.js';
import { TourProvider, useTour } from './Components/Tour/TourContext.js';
import TourGuia from './Components/Tour/TourGuia.js';
import TourMenu from './Components/Tour/TourMenu.js';
import './App.css';
import './Tablet.css';
import './Mobile.css';

import Cerrar from './img/Cerrar.png'
import Share from './img/share.png';


// Registra las acciones de navegación del tour.
// Debe renderizarse DENTRO de <BrowserRouter> para usar useNavigate.
function TourNavActions({ setTourMenuAbierto }) {
  const navigate = useNavigate();
  const { registrarAccion } = useTour();
  useEffect(() => {
    registrarAccion('irAHost', () => navigate('/host'));
    registrarAccion('irAInicio', () => navigate('/'));
    registrarAccion('irAGestion', () => navigate('/host/gestion/personas'));
    registrarAccion('irAPersonaNueva', () => navigate('/host/gestion/personas/nueva'));
    registrarAccion('irAGestionAlmacenes', () => navigate('/host/gestion/almacenes'));
    registrarAccion('irAAlmacenNuevo', () => navigate('/host/gestion/almacenes/nuevo'));
    registrarAccion('irAGestionPublicaciones', () => navigate('/host/gestion/publicaciones'));
    // Navega Y abre el drawer mobile en un solo paso
    registrarAccion('abrirMenuHost', () => {
      navigate('/host');
      setTourMenuAbierto(prev => prev + 1);
    });
    registrarAccion('abrirMenuGestion', () => {
      navigate('/host/gestion/personas');
      if (window.innerWidth <= 767) setTourMenuAbierto(prev => prev + 1);
    });
  }, [registrarAccion, navigate, setTourMenuAbierto]);
  return null;
}

function AppContent() {
  const auth = useAuth();
  const {token} = useToken();
  const [config, setConfig] = useState(localStorage.getItem('config') ? JSON.parse(localStorage.getItem('config')) : {
    idioma : 'es',
    sistema : 'internacional',
  })
  const [user, setUser] = useState({});
  const [modalLogin, setModalLogin] = useState(false);

  // El sync corre al iniciar sesion, cuando el perfil todavia no existe: la fila
  // de cat_user se crea vacia. El paso 2 del alta escribe nombre, apellido y
  // fecha en Cognito, pero nada los bajaba a la base y "Mi Perfil" se quedaba
  // solo con el correo. Esto los sincroniza en cuanto aparecen, una vez por
  // usuario —el ref evita repetirlo en cada render—.
  const perfilSincronizado = useRef(null);
  useEffect(() => {
    const sub = user?.sub;
    if (!sub || !user?.given_name) return;
    if (perfilSincronizado.current === sub) return;
    perfilSincronizado.current = sub;
    syncUsuarioDb(user);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);
  const [modalFiltro, setModalFiltro] = useState(false);
  const [instalar, setInstalar] = useState(false);
  const [tourMenuAbierto, setTourMenuAbierto] = useState(0);
  const [installPromptEvent, setInstallPromptEvent] = useState(null);
  const [iOSinstall, setIOSinstall] = useState(false);
  const [modalAyuda, setModalAyuda] = useState(false);
  
  const iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
  const { iniciarTour, registrarAccion, yaVio, tourActivo } = useTour();

  // Registrar acciones para el tour (sin navigate — las de navón se registran en TourNavActions)
  useEffect(() => {
    registrarAccion('abrirMenu', () => setTourMenuAbierto(prev => prev + 1));
    registrarAccion('abrirModal', () => setModalLogin(true));
  }, [registrarAccion]);

  // Iniciar tour automáticamente la primera vez
  useEffect(() => {
    if (!yaVio()) {
      const timer = setTimeout(() => iniciarTour(), 1200);
      return () => clearTimeout(timer);
    }
  }, []);

  useEffect(()=>{
    sincronizarSesion();
  }, [])

  useEffect(()=>{
    checkNoti();
  }, [token])

  useEffect(()=>{
    localStorage.setItem('config', JSON.stringify(config));
  },[config])

  useEffect(() => {
    setIOSinstall(iOS && !navigator.standalone);
    setTimeout(()=>{
      setIOSinstall(false);
    }, 15000)
    window.addEventListener('beforeinstallprompt', (e) => {
      // Evita que Chrome muestre el mini-infobar
      e.preventDefault();
      // Guarda el evento para que pueda ser llamado más tarde
      setInstallPromptEvent(e);
      setInstalar(true);
    });
    window.addEventListener('appinstalled', () => {
      // La aplicación fue instalada
      setInstalar(false);
    });
  }, []);

  // Antes esto era Hub.listen("auth"), el bus de eventos de Amplify, con un
  // switch por tipo de evento. El contexto de OIDC expone el estado directo,
  // asi que basta con reaccionar a que haya sesion. De paso desaparece el
  // window.location.href que recargaba la pagina entera al volver de Google.
  useEffect(() => {
    if (auth.isAuthenticated && auth.user) {
      sincronizarSesion();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [auth.isAuthenticated, auth.user?.access_token]);

  onMessageListener()?.then(payload => {
    console.log(payload)
    // setShow(true);
    // setNotification(payload)
		setTimeout(()=>{
			// setShow(false);
		},5000)
  }).catch(err => console.log('failed: ', err));

  const checkNoti = async ()=>{
    if(!token){
      const tokenDevice = await deviceToken();
      if(!tokenDevice){
        requestPermission();
      }
    }
  }

  const handleInstallPWA = () => {
    if (!installPromptEvent) return;
    // Muestra el mensaje de instalación
    installPromptEvent.prompt();
    // Espera a que el usuario responda a la pregunta
    installPromptEvent.userChoice.then((choiceResult) => {
      if (choiceResult.outcome === 'accepted') {
        console.log('El usuario aceptó la instalación');
      } else {
        console.log('El usuario rechazó la instalación');
      }
      // Borra el evento guardado
      setInstallPromptEvent(null);
    });
  };

  // Los atributos ya vienen en el token: `profile` trae sub, email,
  // given_name, family_name y birthdate. Antes cada uno de estos pasos era una
  // llamada de red a Cognito (fetchUserAttributes + fetchAuthSession).
  async function sincronizarSesion() {
    try {
      const perfil = auth.user?.profile;
      const accessToken = auth.user?.access_token;
      if (!perfil || !accessToken) return;

      // Enlaza el sub del proveedor con cat_user antes de pedir datos del host
      await syncUsuarioDb(perfil);
      await getData({ ...perfil, old: true }, accessToken);
    } catch (err) {
      console.log('sincronizarSesion', err);
    }
  }

  async function syncUsuarioDb(usuarioAttr){
    try {
      const usuario = usuarioAttr || auth.user?.profile;
      if(!usuario || Object.keys(usuario).length === 0) return null;

      const data = {
          "name": usuario?.given_name || '',
          "lastname": usuario?.family_name || '',
          "password": usuario?.password,
          "cellphone": usuario?.phone_number || '',
          "uuid": usuario?.sub,
          "email": usuario?.email,
          "birthdate": usuario?.birthdate || '',
      }

      // El alta exige el token: el servidor toma el sub de ahi y NO del body.
      // Antes confiaba en el uuid que se le mandara, asi que bastaba enviar el
      // correo de otra persona para heredar su cuenta. Sin esta cabecera la
      // peticion responde 401 y el usuario se queda sin fila en cat_user.
      const accessToken = auth.user?.access_token;
      if (!accessToken) {
        console.warn('syncUsuarioDb: sin sesión todavía, no se da de alta');
        return null;
      }

      const json = await fetch(baseUrl+"api/alta/Usuario", {
          method: "post",
          headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json',
              'Authorization': `Bearer ${accessToken}`,
          },
          body: JSON.stringify(data),
      }).then(response=>response.json());

      console.log('syncUsuarioDb', json);
      if (json?.idUser && usuario?.picture) {
        await subirFoto(usuario, accessToken);
      }
      return json;
    } catch (error) {
      console.error('syncUsuarioDb', error);
      return null;
    }
  }

  async function handleSignIn(){
    return syncUsuarioDb();
  }

  // Cognito no mapea `picture` en ninguno de los dos IdP, asi que este valor
  // puede llegar vacio, o como el JSON {"data":{"url":...}} que manda Facebook.
  // Sin normalizarlo, fetch() lo resolvia como ruta relativa, el rewrite de SPA
  // devolvia index.html con 200, y ese HTML terminaba guardado como avatar.
  const urlDeFoto = (picture) => {
    if (!picture || typeof picture !== 'string') return null;
    let valor = picture.trim();
    if (valor.startsWith('{')) {
      try { valor = JSON.parse(valor)?.data?.url || ''; } catch { return null; }
    }
    try {
      const u = new URL(valor);
      return (u.protocol === 'https:' || u.protocol === 'http:') ? u.href : null;
    } catch { return null; }
  };

  const EXT_POR_TIPO = {
    'image/jpeg': 'jpg', 'image/png': 'png', 'image/webp': 'webp',
    'image/gif': 'gif', 'image/heic': 'heic',
  };

  const subirFoto = async (usuario, accessToken)=>{
    if (!accessToken) return;
    const origen = urlDeFoto(usuario.picture);
    if (!origen) return;
    try {
      const response = await fetch(origen);
      if (!response.ok) return;
      // El backend acepta solo imagenes; sin esta guarda subiamos cualquier cosa
      // que respondiera 200, incluido el propio index.html.
      const tipo = (response.headers.get('content-type') || '').split(';')[0].trim();
      if (!EXT_POR_TIPO[tipo]) {
        console.warn('User/Photo: la foto de perfil no es una imagen soportada', tipo);
        return;
      }
      const blob = await response.blob();
      const data = new FormData();
      // Con nombre y tipo explicitos: si no, originalname queda en "blob".
      data.append('file', blob, `avatar.${EXT_POR_TIPO[tipo]}`);

      const res = await fetch(baseUrl+"User/Photo", {
        method: "post",
        headers: {
            'Accept': 'application/json',
            'Authorization': `Bearer ${accessToken}`,
        },
        body: data,
      });
      const json = await res.json().catch(() => ({}));
      if (!res.ok) console.warn('User/Photo', json);
    } catch (error) {
        console.warn('User/Photo', error);
    }
  }

  const getData = async (userdata, accessToken)=>{
    // console.log("llamando getdata")
    // console.log(user);
    const result1 = await fetch(baseUrl+"User/Info",{
			method : 'get',
			headers: {
				'Content-Type': 'application/json',
				'Accept': 'application/json',
				'Authorization': `Bearer ${accessToken}`,
			},
		}).then(response=> response.json())
		.then(json=>{
      console.log(json)
      userdata.companies = json?.data?.companies || 0;
      userdata.bookings = json?.data?.bookings || 0;
      userdata.notifications = {
        client: json?.data?.notifications?.client || 0,
        host: json?.data?.notifications?.host || 0,
      }
      userdata.posts = json?.data?.posts || 0;
      userdata.favs = json?.data?.favs;
      userdata.url = json?.data?.url || '';
      userdata.Acepterms = json?.data?.Acepterms || '';
      setUser({...userdata});
			return json;
		})
		.catch(error=>{
			console.log(error);
		})
  }

  return (
    <>
    <BrowserRouter basename='/'>
      <TourNavActions setTourMenuAbierto={setTourMenuAbierto} />
      <div className="contenedor">
        {iOSinstall &&
          <div className="iOSinstall" onClick={()=>{
            setIOSinstall(false);
          }}>
            <span>
              <b>Instala la app:</b> Presiona <img src={Share}/> y luego selecciona "Agregar a inicio"
            </span>
            <div className="triangulo"></div>
          </div>
        }
        {false && instalar &&
          <div onClick={handleInstallPWA} className='instalar'>
            <span>Logo</span>
            <span>Instala la app</span>
            <span className='cerrar'>
              <img src={Cerrar} onClick={(e)=>{
                e.stopPropagation();
                setInstalar(false);
              }}/>
            </span>
          </div>
        }
          <BuscadorProvider>
            <NavBar user={user} setUser={setUser} modalLogin={modalLogin} setModalLogin={setModalLogin} modalFiltro={modalFiltro} setModalFiltro={setModalFiltro} tourMenuAbierto={tourMenuAbierto} setModalAyuda={setModalAyuda} tourActivo={tourActivo}/>
            <Routes>
              <Route path='/' element={<Inicio modalFiltro={modalFiltro} setModalFiltro={setModalFiltro} setModalLogin={setModalLogin}/> }></Route>
              <Route path='/dashboard' element={<Dashboard/>}></Route>
              <Route path='/mi-stock' element={<Stock/>}></Route>
              <Route path='/mis-productos' element={<MisProductos/>}></Route>
              <Route path='/favoritos' element={<Inicio modalFiltro={modalFiltro} setModalFiltro={setModalFiltro} favoritos={true}/>}></Route>
              <Route path='/perfil' element={<Cuenta setUser={setUser}/>}></Route>
              <Route path='/login' element={<Login user={user} setUser={setUser} pagina={true}/>}></Route>
              <Route path='/almacen/:id' element={<Almacen user={user} setModalLogin={setModalLogin}/>}>
                <Route path='fotos' element={<Fotos/>}></Route>
                <Route path='fotos/:idPhoto' element={<Fotos/>}></Route>
              </Route>
              <Route path='/unirte' element={<Unirte user={user} modalLogin={modalLogin} setModalLogin={setModalLogin}/>}></Route>
              <Route path='/host' element={<DashFechas/>}></Route>
              <Route path='/host/gestion' element={<NavBarGestion/>}>
                <Route path='' element={<HostPersonas/>}></Route>
                <Route path='personas' element={<HostPersonas/>}></Route>
                <Route path='personas/nueva' element={<Persona/>}></Route>
                <Route path='personas/:id' element={<Persona/>}></Route>
                <Route path='personas/:idCompany/almacenes' element={<HostAlmacenes/>}></Route>
                <Route path='personas/:idCompany/almacenes/nuevo' element={<InfoAlmacen/>}></Route>
                <Route path='personas/:idCompany/almacenes/nuevo/:sel' element={<InfoAlmacen/>}></Route>
                <Route path='almacenes' element={<HostAlmacenes/>}></Route>
                <Route path='almacenes/seleccionar' element={<HostAlmacenes selectAlmacen={true}/>}></Route>
                <Route path='almacenes/nuevo' element={<InfoAlmacen/>}></Route>
                <Route path='almacenes/:id' element={<InfoAlmacen/>}></Route>
                <Route path='almacenes/nuevo/:sel' element={<InfoAlmacen/>}></Route>
                <Route path='almacenes/:id/:sel' element={<InfoAlmacen/>}></Route>
                <Route path='publicaciones/' element={<MisPublicaciones/>}></Route>
                <Route path='publicaciones/:id' element={<Publicaciones/>}></Route>
                <Route path='publicaciones/:id/nueva' element={<Publicacion/>}></Route>
                <Route path='publicaciones/:id/:idPost' element={<Publicacion/>}></Route>
              </Route>
              {/*
              <Route path='/host/publicaciones/' element={<MisPublicaciones/>}></Route>
              <Route path='/host/publicaciones/:id' element={<Publicaciones/>}></Route>
              <Route path='/host/publicaciones/:id/nueva' element={<Publicacion/>}></Route>
              <Route path='/host/publicaciones/:id/:idPost' element={<Publicacion/>}></Route>
              <Route path='/host/dashboard' element={<NavBarCuenta/>}>
              */}
              <Route path='/host/dashboard' element={<NavBarCuenta/>}>
                <Route path='' element={<DashEspacios/>}></Route>
                <Route path='reservaciones/espacios' element={<DashEspacios/>}></Route>
                <Route path='reservaciones/almacenes' element={<DashAlmacenes/>}></Route>
                <Route path='reservaciones/publicaciones' element={<DashPublicaciones/>}></Route>
                <Route path='reservaciones/ubicaciones' element={<DashUbicacion/>}></Route>
                <Route path='reservaciones/reservaciones' element={<DashFechas/>}></Route>
                <Route path='finanzas/' element={<Outlet/>}>
                  <Route path='' element={<DashFinanzas/>}></Route>
                  <Route path='pagos' element={<DashFinanzas/>}></Route>
                  <Route path='disputas' element={<DashFinanzas/>}></Route>
                  <Route path='transferencias' element={<DashFinanzas/>}></Route>
                </Route>
              </Route>
              <Route path='/host/reservaciones/solicitudes' element={<DashFechas solicitudes={true} key={'solicitudes'}/>}></Route>
              <Route path='/host/reservaciones/' element={<DashFechas key={'inicio'}/>}>
                {/* <Route path='' element={<DashFechas/>}/>
                <Route path='lista' element={<DashFechas/>}/>
                <Route path='calendario' element={<CalendarioReservaciones/>}/> */}
              </Route>
              <Route path='/host/inout/*' element={<InoutHost/>}></Route>
              <Route path='/host/reservaciones/:id' element={<ReservacionHost/>}></Route>
              <Route path='/reservar/:id' element={<Reservar user={user} setModalLogin={setModalLogin}/>}></Route>
              <Route path='/reservaciones/' element={<Reservados/>}></Route>
              <Route path='/reservaciones/:id' element={<Reserva/>}>
                <Route path='' element={<Reservar user={user} setModalLogin={setModalLogin}/>}></Route>
                <Route path='inout' element={<Inout/>}></Route>
              </Route>
              <Route path='/completado/:id' element={<Reservacion/>}></Route>
              <Route path='/confirmando/:id' element={<Reservacion/>}></Route>
              <Route path='/transferencia/' element={<Transferencia/>}></Route>
              <Route path='/about' element={<About/>}></Route>
              <Route path='/faqs' element={<Faqs/>}></Route>
              <Route path='/ayuda' element={<Faqs/>}></Route>
              <Route path='/host/notificaciones/' element={<Notificaciones user={user} setUser={setUser} tipo={'host'}/>}></Route>
              <Route path='/notificaciones/' element={<Notificaciones user={user} setUser={setUser} tipo={'client'}/>}></Route>

              <Route path='/host/mensajes/:idSupport?' element={<Mensajes user={user} setUser={setUser} tipo={'host'}/>}></Route>
              <Route path='/mensajes/:idSupport?' element={<Mensajes user={user} setUser={setUser} tipo={'client'}/>}></Route>
              
            </Routes>  
          </BuscadorProvider>
        <Footer/>
        <Contacta/>
        <BottomBar user={user}></BottomBar>
      </div>
    </BrowserRouter>
    {/* Tour guiado */}
    <TourGuia />

    {/* Botón flotante de ayuda — siempre visible en mobile */}
    {!tourActivo && !modalAyuda && (
      <button
        className="btn-ayuda-flotante"
        onClick={() => setModalAyuda(true)}
        title="Centro de ayuda"
        aria-label="Abrir centro de ayuda"
      >
        <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="12" cy="12" r="10"/>
          <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"/>
          <line x1="12" y1="17" x2="12.01" y2="17"/>
        </svg>
        <span>Ayuda</span>
      </button>
    )}

    {/* Modal de selección de tour */}
    {modalAyuda && <TourMenu onClose={() => setModalAyuda(false)} />}
    </>
  );
}

function App() {
  return (
      <TourProvider>
        <AppContent />
      </TourProvider>
  );
}

export default App;
